
const gemini=process.env.REACT_APP_GEMINI;
const gemini2 = process.env.REACT_APP_GEMINI2;

export {gemini,gemini2};